import { AxiosHeaders, InternalAxiosRequestConfig } from 'axios';
import { AccessToken } from '../access-token';
import { HttpServiceConfigurator } from './http-service-configurator';
import RefreshTokenService from './refresh-token-service';

export class RefreshableHttpServiceConfigurator extends HttpServiceConfigurator {
  static getRefreshTokenHeaders() {
    const headers = new AxiosHeaders();
    const refreshToken = AccessToken.getRefreshToken();
    if (refreshToken) headers.set('x-refresh-token', refreshToken);
    return headers;
  }

  async prepareRequestConfig(baseConfig: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> {
    if (!baseConfig.headers?.['x-refresh-token']) await RefreshTokenService.checkTokens();

    const config = {
      ...baseConfig,
      ...this.getHttpClientConfig(),
      headers: new AxiosHeaders({
        ...baseConfig.headers,
        ...HttpServiceConfigurator.getHeaders(baseConfig),
      })
    };
    return config;
  }
}